<script setup lang="ts">
  import { computed } from 'vue';
  import { radioIndicatorClass } from './RadioIndicator.css';
  import type { RadioIndicatorProps } from './RadioIndicator.types';

  const props = withDefaults(defineProps<RadioIndicatorProps>(), {
    checked: false,
    disabled: false,
  });

  const state = computed(() => (props.checked ? 'checked' : 'unchecked'));
</script>

<template>
  <div
    :class="radioIndicatorClass"
    aria-hidden="true"
    :data-state="state"
    :data-disabled="disabled ? '' : undefined"
  />
</template>
